
import {
    request,
    requestPublic
} from './request.js'
// 获取对应页面的操作按钮 /SBCenterAdminApi/TheMenu/GetTheMenuButtons
// 获取定制化学员列表页的动态按钮
export function GetTheMenuButtonsStudent(data) {
  return request({
    url: "/api4/TEducationStudentAdminApi/ListPageAdmin/GetTheMenuButtons",
    method: "get",
    params: data,
  });
}

// 获取对应页面的操作按钮 /SBCenterAdminApi/TheMenu/GetTheMenuButtons
export function GetTheMenuButtons(menuId, isAuthorize, studentPageId) {
  return request({
    url: "/api4/SBCenterAdminApi/TheMenu/GetTheMenuButtons",
    method: "get",
    params: {
      theMenuId: menuId,
      isAuthorize: isAuthorize,
      studentPageId: studentPageId,
    },
  });
}